import Cookies from "universal-cookie";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";

const cookies = new Cookies();

function OrdersOverview() {
  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          History
        </MDTypography>
        <MDBox mt={0} mb={2}>
          
        </MDBox>
      </MDBox>
      <MDBox p={2}>
      {cookies.get("auth-token1")?( 
        <>
        <TimelineItem
          color="success"
          icon="notifications"
          title="$2400, Design changes"
          dateTime="22 APR 7:20 PM"
        />
        <TimelineItem
          color="error"
          icon="inventory_2"
          title="New order #1832412"
          dateTime="21 APR 11 PM"
        />
        <TimelineItem
          color="info"
          icon="shopping_cart"
          title="Server payments for April"
          dateTime="21 APR 9:34 PM"
        />
        <TimelineItem
          color="warning"
          icon="payment"
          title="New card added for order #4395133"
          dateTime="20 APR 2:20 AM"
        />
        <TimelineItem
          color="primary"
          icon="vpn_key"
          title="New card added for order #4395133"
          dateTime="18 APR 4:54 AM"
          lastItem
        /></>):(
          <h1 style={{textAlign: "center"}}>SIGN IN FIRST</h1>
        )}
      </MDBox>
    </Card>
  );
}

export default OrdersOverview;
